<template>
  <div v-if="loading" class="text-center mt-5 font-2xl text-muted">
    <i class="fal fa-spinner fa-spin" /> Audit Data Loading...
  </div>

  <div v-else class="animated fadeIn">
    <basic-heading title="Audit Trail" class="mb-3">
      <template #right-content>
        <header-button-group :button_config="button_config">
        </header-button-group>
      </template>
    </basic-heading>

    <permission-alert-gate :permissions="'read sample type'">
      <template #gated-content>
        <div>
          <h3>
            Change Log
            <b-button class="float-right" variant="success" :to="`/${route_root}/${sample_type_id}/audit-trail-history`">
              View History
            </b-button>
          </h3>
        </div>
        <AuditChangeLogTable
          :model="sample_type"
        />

        <h3>Relations</h3>
        <AuditRelationTable
          :model="sample_type"
        />
      </template>
    </permission-alert-gate>
  </div>
</template>

<script>
import ToastNotifications from '@/components/shared/mixins/ToastNotifications'
import PermissionAlertGate from "@/components/permission/PermissionAlertGate"
import AuditChangeLogTable from '@/components/shared/audit/AuditChangeLogTable'
import AuditRelationTable from '@/components/shared/audit/AuditRelationTable'
import BasicHeading from '@/components/shared/BasicHeading'
import HeaderButtonGroup from '@/components/shared/headerbuttons/HeaderButtonGroup'
import { TestWorkflowRoutes } from '@/router/lab/TestWorkflowRoutes'
import SampleTypeModel from '@/models/lab/SampleTypeModel'

export default {
  name: "WorkflowTestAuditTrail",
  components: {
    PermissionAlertGate,
    AuditChangeLogTable,
    AuditRelationTable,
    BasicHeading,
    HeaderButtonGroup
  },
  mixins: [ToastNotifications],
  data () {
    return {
      loading: true,
      sample_type_id: this.$route.params.sample_type_id || null,
      sample_type: null
    };
  },
  computed: {
    button_config() {
      return {
        buttons: [
          {
            icon: "fa-eye",
            linkto: `/${this.route_root}/${this.sample_type_id}`,
            title: "View test workflow",
            variant: "info",
          }
        ]
      }
    },

    route_root () {
      return TestWorkflowRoutes.fetchRoot()
    }
  },
  async created () {
    this.loading = true

    this.sample_type = new SampleTypeModel({ id: this.sample_type_id })

    const params = {}
    params.connection = ['auditCreatedBy', 'auditUpdatedBy']

    this.sample_type.fetch({ params }).then(() => {
      this.loading = false
    })
  },
}
</script>
